import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const I18nContext = createContext(null);
const STORAGE_KEY = "ovolaay_lang";

function resolve(obj, path) {
  return path.split(".").reduce((acc, k) => (acc && acc[k] != null ? acc[k] : undefined), obj);
}

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem(STORAGE_KEY) || "fr");

  const setLang = useCallback((l) => {
    localStorage.setItem(STORAGE_KEY, l);
    setLangState(l);
    document.documentElement.lang = l;
  }, []);

  const t = useCallback(
    (key, vars) => {
      let str = resolve(translations[lang], key);
      if (str === undefined) str = resolve(translations.fr, key);
      if (str === undefined) return key;
      if (vars) Object.entries(vars).forEach(([k, v]) => { str = str.replace(`{${k}}`, v); });
      return str;
    },
    [lang]
  );

  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export function useT() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useT must be used within I18nProvider");
  return ctx;
}
